<template>
  <div class="history__content">
    <div
      v-for="(item, index, key) in data"
      :key="key"
      class="content__item"
    >
      <div class="item__label font-[12px]">
        <span class="mx-1">{{ item.label }}</span>
        <span v-if="item.tip">{{ item.tip }}</span>
        <Tipinfo v-if="item.tooltip" :width="item.tooltipWidth">
          {{ item.tooltip }}
        </Tipinfo>
      </div>
      <div class="item__value">
        <span v-if="prefix">
          {{ prefix }}
        </span>
        <span v-show="item.showNegativeSign && item.value && item.value < 0">
          -
        </span>
        <span>
          {{ Math.abs(item.value) }}
        </span>
        <span v-if="item.unitLabel">
          {{ item.unitLabel }}
        </span>
      </div>
      <div v-if="item.subLabel" class="item__sub-label">{{ item.subLabel }}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Tipinfo from '@/components/TipInfo.vue'
export default defineComponent({
  name: 'StatisticBlock',
  components: { Tipinfo },
  props: {
    data: { type: Array, default: () => [] },
    prefix: { type: String, default: '$' },
  },
})
</script>

<style scoped lang="postcss">
.history__content,
.record__content {
  @apply flex p-[3px] min-h-[79px] bg-white;
}

.history__content {
  @apply mt-[22px];
}

.content__item + .content__item::before {
  content: "";
  position: absolute;
  top: 10%;
  left: 0;
  width: 2px;
  height: 80%;
  background-color: #DCDFE6;
}

.content__item {
  position: relative;
  flex: 1 1 33%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
}

.content__item .item__label {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  color: #2d271b;
  font-size: 14px;
  line-height: 21px;
}

.content__item .item__value {
  margin-top: 4px;
  @apply text-primary-100;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
}

.content__item .item__sub-label {
  margin-top: 4px;
  @apply text-gray-60;
  font-size: 12px;
  line-height: 18px;
}
</style>
